import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthStrategy } from '../auth/auth-strategy';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(AuthStrategy.applyAuth(req)).pipe(
      catchError((error: unknown) => {
        // Brands without a login flow (see requiresLoginFlow) authenticate implicitly on every
        // request, so an unauthorized response is the only signal that the user isn't logged in.
        if (!AuthStrategy.requiresLoginFlow() && error instanceof HttpErrorResponse
          && (error.status === 401 || error.status === 403)) {
          this.router.navigate(['/not-logged-in']);
        }
        return throwError(() => error);
      })
    );
  }
}
